export default "__VITE_ASSET__5OL$3aVw__"